module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel_contrate_iberostar.d80835d0.jpg";